export default __webpack_public_path__ + "static/media/bicycle.33db70f1.svg";